import React, { useRef, useEffect } from 'react'

import { isMobileOrIPad } from 'utils/device'

import { Video } from './styles'

export default function VideoTrack({
    track,
    isLocal,
    priority,
    isTeacherIdentity,
    enableScreenShare,
    position,
}) {
    const ref = useRef(null)

    useEffect(() => {
        const el = ref.current
        if (el) el.muted = true
        if (track.setPriority && priority) {
            track.setPriority(priority)
        }
        track.attach(el)
        return () => {
            track.detach(el)
            if (track.setPriority && priority) {
                // Passing `null` to setPriority will set the track's priority to that which it was published with.
                track.setPriority(null)
            }
        }
    }, [track, priority])

    const isFrontFacing =
        track.mediaStreamTrack.getSettings().facingMode !== 'environment'
    const shouldRotate = isLocal && isFrontFacing ? true : false

    const video = (
        <Video
            ref={ref}
            shouldRotate={shouldRotate}
            isScreenShare={enableScreenShare}
            style={{ position }}
            isTeacherIdentity={isTeacherIdentity}
            autoPlay
            playsInline
            webkit-playsinline="true"
        />
    )

    console.count('VideoTrack component')

    return (
        <>
            {isMobileOrIPad
                ? isTeacherIdentity || isLocal || enableScreenShare
                    ? video
                    : null
                : video}
        </>
    )
}
